export class Integration {
    id: string;
    indicators: string;
    name: string;
}